export default "__VITE_ASSET___7kGc7Uo__"